import { render, staticRenderFns } from "./cluster.vue?vue&type=template&id=54fe7bbc&"
import script from "./cluster.vue?vue&type=script&lang=js&"
export * from "./cluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!/Users/pjabang/projects/taybull-ui/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
